'use strict';

module.exports = {
    w: 0,
    cw: 1,
};
